export const APP_MODES = {
  PUBLIC: 'public',
  PERSONAL: 'personal'
};

export const getAppMode = () => {
  const configuredMode = (
    window.RUNTIME_CONFIG?.appMode ||
    process.env.REACT_APP_APP_MODE ||
    APP_MODES.PERSONAL
  ).toLowerCase();

  return configuredMode === APP_MODES.PUBLIC ? APP_MODES.PUBLIC : APP_MODES.PERSONAL;
};

export const isPersonalApp = () => getAppMode() === APP_MODES.PERSONAL;

export const isPublicApp = () => getAppMode() === APP_MODES.PUBLIC;
